import * as React from "react";
export class HeadingTitle extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "rj-heading-title", "data-uat": "heading-title" },
            React.createElement("span", { className: "rj-heading-title__name", "data-uat": "heading-title-name" },
                this.props.name,
                React.createElement(Count, { count: this.props.count }))));
    }
}
/* eslint no-null/no-null: "off" */
const Count = (props) => props.count !== ""
    ? React.createElement("span", { className: "rj-heading-title__count", "data-uat": "heading-title-count" }, props.count)
    : null;
//# sourceMappingURL=HeadingTitle.js.map